import {
  ICreateAccountRequest,
  ICreateApplicationRequest,
  ICreateOrUpdateBorrowerRequest,
  IExistingBorrowerRequest,
  IRunGpsCheckResponse,
  ISnowflakeBranchIdMismatchCheckResponse,
  ISnowflakeBorrowerStatusCheckResponse,
  ISnowflakePrescreenedOfferQueryResponse,
  ISnowflakeZipCodeCheckResponse,
  IUtmDataValues,
  ICheckPrescreenShortPageOfferResponse,
} from 'api/curo/ApplyProcessApi';
import { ApplyFormFields, IApplyFormValues } from 'components/curo-components/forms/ApplyForm';
import {
  ContactInformationFields,
  IContactInformationFormValues,
} from 'components/curo-components/forms/ContactInformationForm/constants';

export const mapFormFieldsToCreateBorrowerRequest = (
  values: IContactInformationFormValues & IApplyFormValues,
): ICreateOrUpdateBorrowerRequest => {
  return {
    borrowerCity: values[ApplyFormFields.BorrowerCity],
    borrowerDateOfBirth: values[ApplyFormFields.BorrowerDateOfBirth],
    borrowerEmail: values[ContactInformationFields.BorrowerEmail],
    borrowerFirstName: values[ApplyFormFields.BorrowerFirstName],
    borrowerLastName: values[ApplyFormFields.BorrowerLastName],
    borrowerPhone: values[ContactInformationFields.BorrowerPhone],
    borrowerSSN: values[ApplyFormFields.BorrowerSSN],
    borrowerState: values[ApplyFormFields.BorrowerState],
    borrowerStreetAddress: values[ApplyFormFields.BorrowerStreetAddress],
    borrowerZipOrPostalCode: values[ApplyFormFields.BorrowerZipOrPostalCode],
    borrowerMarketingMessagesAccepted:
      values[ContactInformationFields.TelephoneAndElectronicCommunicationPolicy],
  };
};

export const mapFormFieldsToCheckExistingBorrowerRequest = (
  values: IContactInformationFormValues & IApplyFormValues,
): IExistingBorrowerRequest => {
  return {
    borrowerPersonalIdNumber: values[ApplyFormFields.BorrowerSSN],
    borrowerPhone: values[ContactInformationFields.BorrowerPhone],
    borrowerEmail: values[ContactInformationFields.BorrowerEmail],
  };
};

export const mapFormFieldsToCreateApplicationRequest = ({
  borrowerId,
  values,
  utmData,
  gpsCheckData,
  snowflakeData,
  prescreenShortPageOfferData,
}:{
  borrowerId: string,
  values: IContactInformationFormValues & IApplyFormValues,
  utmData: IUtmDataValues,
  gpsCheckData?: IRunGpsCheckResponse,
  snowflakeData?: ISnowflakePrescreenedOfferQueryResponse 
    | ISnowflakeZipCodeCheckResponse 
    | ISnowflakeBranchIdMismatchCheckResponse 
    | ISnowflakeBorrowerStatusCheckResponse,
  prescreenShortPageOfferData?: ICheckPrescreenShortPageOfferResponse,
}): ICreateApplicationRequest => {
  return {
    borrowerId,
    ...gpsCheckData,
    ...snowflakeData,
    ...utmData,
    prescreenedOfferType: prescreenShortPageOfferData?.prescreenedOfferType,
  };
};

export const mapFormFieldsToCreateAccountRequest = (
  borrowerId: string,
  values: IContactInformationFormValues,
): ICreateAccountRequest => {
  return {
    borrowerId,
    borrowerEmail: values[ContactInformationFields.BorrowerEmail],
    borrowerPhone: values[ContactInformationFields.BorrowerPhone],
  };
};
